/* tslint:disable */
/* eslint-disable */
export enum ServiceOrderStatus {
  Order = 'ORDER',
  Invoiced = 'INVOICED',
}
